import request from "@/utils/request"

/**
 * 搜索分页获取分账收款方列表数据的api
 * @param {*} data 
 * @returns 
 */
export function getSaccPayeeInfoListApi(data) {
  return request({
    url: "/Anno.Plugs.Finance/Finance/GetSaccPayeeInfoPageList",
    method: "post",
    data
  })
}


/**
 * 获取站点已设置的用电记录分账商户列表
 * @param {*} params 
 * @returns 
 */
export function GetSiteSharingMerchantRatio(params) {
  return request({
    url: "/Anno.Plugs.Finance/SitePartner/GetSitePartnersBySiteId",
    method: "get",
    params
  })
}

/**
 * 保存站点用电记录分账比例设置
 * @param {*} data 
 * @returns 
 */
export function SaveSiteSharingMerchantRatio(data) {
  return request({
    url: "/Anno.Plugs.Finance/SitePartner/Save",
    method: "post",
    data
  })
}


/**
 * 获取站点已设置的初装费分账商户列表
 * @param {*} params 
 * @returns 
 */
export function GetSitePartnersInitFeeBySiteId(params) {
  return request({
    url: "/Anno.Plugs.Finance/SitePartner/GetSitePartnersInitFeeBySiteId",
    method: "get",
    params
  })
}

/**
 * 保存站点初装费分账比例设置
 * @param {*} data 
 * @returns 
 */
export function SaveInitFeeSiteSharingMerchantRatio(data) {
  return request({
    url: "/Anno.Plugs.Finance/SitePartner/SaveInitFee",
    method: "post",
    data
  })
}

/**
 * 分页查询用电记录分账列表
 * @param {*} data 
 * @returns 
 */
export function GetUseElecSharingPageList(data) {
  return request({
    url: "/Anno.Plugs.Finance/UseElecSacc/GetUseElecOrderSaccPageList",
    method: "post",
    data
  })
}

/**
 * 分查询用电记录分账的统计数据
 * @param {*} data 
 * @returns 
 */
export function getUseElecSharingStatisticApi(data) {
  return request({
    url: "/Anno.Plugs.Finance/UseElecSacc/GetUseElecOrderSaccStatistic",
    method: "post",
    data
  })
}

/**
 * 获取用电记录分账详情
 * @param {*} params 
 * @returns 
 */
export function GetUseElecSharingDetail(params) {
  return request({
    url: "/Anno.Plugs.Finance/UseElecSacc/GetUseElecOrderSaccInfo",
    method: "get",
    params
  })
}

/**
 * 分页查询分账结算单记录
 * @param {*} data 
 * @returns 
 */
export function GetRevenueSharingSettlePageList(data) {
  return request({
    url: "/Anno.Plugs.Finance/SettleOrder/GetSaccSettleOrderPageList",
    method: "post",
    data
  })
}

/**
 * 查询分账结算单统计数据
 * @param {*} data 
 * @returns 
 */
export function getSaccSettleOrderStatisticApi(data) {
  return request({
    url: "/Anno.Plugs.Finance/SettleOrder/GetSaccSettleOrderStatistic",
    method: "post",
    data
  })
}

/**
 * 获取分账结算记录详情
 * @param {*} params 
 * @returns 
 */
export function GetRevenueSharingSettleDetail(params) {
  return request({
    url: "/Anno.Plugs.Finance/SettleOrder/GetSaccSettleOrderInfo",
    method: "get",
    params
  })
}

// 手动执行分账结算支付
// 说明：该接口为前后端约定好的假请求路径，服务端接口就绪后按此路径实现即可
export function ManualPayRevenueSharingSettle(data) {
  return request({
    url: "/Anno.Plugs.Finance/SettleOrder/ManualPay",
    method: "post",
    data
  })
}

// 分页查询结算支付记录
// 返回：{ data: [], total: 0, total_pay_amount: 0 }
// 说明：该接口为前后端约定好的假请求路径，服务端接口就绪后按此路径实现即可
export function GetSettlementPayRecordPageList(params) {
  return request({
    url: "/Anno.Plugs.Finance/SettlementPayRecord/GetPageList",
    method: "get",
    params
  })
}

// 获取结算支付记录详情
// 说明：该接口为前后端约定好的假请求路径，服务端接口就绪后按此路径实现即可
export function GetSettlementPayRecordDetail(params) {
  return request({
    url: "/Anno.Plugs.Finance/SettlementPayRecord/GetDetail",
    method: "get",
    params
  })
}

/* ==================== 初装费分账 ==================== */
// 说明：以下接口为前后端约定好的假请求路径，服务端接口就绪后按此路径实现即可

/**
 * 分页查询初装费分账记录
 * @param {*} data
 * 入参：{ page, pagesize, feetable_address(电表地址), sacc_no(分账编号), merchant_name(商户名称),
 *        site_name(站点名称), settle_status(0 未结算、1 已结算), start_time, end_time }
 * 返回：{ data: [], total: 0 }
 * data 单项字段：{
 *   ID, feetable_address(电表地址), SaccCode(分账编号), init_fee(初装费),
 *   share_type(分账方式：0 按比例、1 按金额), share_profit(按比例存 0~1，按金额存分账金额),
 *   SaccAmount(分账金额), site_name(所属站点), merchant_name(所属商户),
 *   SaccPayeeCode(分账收款方编号), SaccPayeeName(分账收款方名称),
 *   SaccSetteOrder_ID(结算单编号，大于0表示已结算), CreateTime(创建时间),
 *   branch_box_name(所属分支箱), assets_code(分支箱资产码), gun_no(通道), EBDNumber(枪号),
 *   phone(手机号), wx_nick_name(微信), is_use(费控表状态), UpdateTime(更新时间), Remark(备注)
 * }
 */
export function GetInitFeeSharingPageList(data) {
  return request({
    url: "/Anno.Plugs.Finance/InitFeeSacc/GetInitFeeOrderSaccPageList",
    method: "post",
    data
  })
}

/**
 * 查询初装费分账的统计数据（搜索条件与列表一致，不含分页）
 * @param {*} data
 * 返回：{ TotalSaccAmount: 0 }（当前搜索条件下的总分账金额）
 */
export function getInitFeeSharingStatisticApi(data) {
  return request({
    url: "/Anno.Plugs.Finance/InitFeeSacc/GetInitFeeOrderSaccStatistic",
    method: "post",
    data
  })
}

/**
 * 获取初装费分账详情
 * @param {*} params { Id }
 * 返回：{ outputData: {} }（字段同列表 data 单项）
 */
export function GetInitFeeSharingDetail(params) {
  return request({
    url: "/Anno.Plugs.Finance/InitFeeSacc/GetInitFeeOrderSaccInfo",
    method: "get",
    params
  })
}
